import React, { useState, useRef, useEffect } from "react";

const LeagueDropdown = ({ leagueData, leagueId, handleLeagueChange, subscriptionStatus, showPopupSignup }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const dropdownRef = useRef(null);

  const filteredLeagues = leagueData.filter((item) =>
    item.leaguename.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelect = (id, isLocked) => {
    if (isLocked) return; // prevent selecting locked league
    handleLeagueChange({ target: { value: id } });
    setIsOpen(false);
    setSearchTerm("");
  };

  useEffect(() => {
    if (showPopupSignup) {
      setIsOpen(false);
    }
  }, [showPopupSignup]);



  return (
    <div className="AF-select" ref={dropdownRef} onClick={() => setIsOpen(!isOpen)}>
      {/* Selected value */}
      <div className="dropdown-text-bet">
        {leagueData.length > 0
          ? leagueData.find((item) => String(item.leagueid) === String(leagueId))?.leaguename ||
            "Select league"
          : "Select league"}
      </div>

      {isOpen && (
        <div className="dropdown-list-best" style={{ color: "black" }}>
          {/* Search inside dropdown */}
          <div className="AF-formControl_tribet">
            <input
              type="text"
              placeholder="Search league..."
              className="w-full p-2 border-b outline-none"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              autoFocus
            />
          </div>

          {filteredLeagues.length > 0 ? (
            filteredLeagues.map((item) => {
              const isEngland = item.leaguename === "England - Premier League";
              const isLocked = (subscriptionStatus === "Free" || subscriptionStatus === null || subscriptionStatus === "Pending") && !isEngland;

              return (
                <div
                  key={item.leagueid}
                  className={`AF-formControl_multibet ${
                    String(item.leagueid) === String(leagueId) ? "selected-league-instantbet" : ""
                  } ${isLocked ? "locked" : ""}`}
                  onClick={() => handleSelect(item.leagueid, isLocked)}
                  title={isLocked ? "Available in Pro. Build your bet with full stats suggestions (£4.99/month).": ''}
                >
                  {item.leaguename} {isLocked && <span className="lock-icon" style={{marginLeft:'5px'}}>🔒</span>}
                </div>
              );
            })
          ) : (
            <div className="message" style={{ textAlign: "center" }}>
              League not available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default LeagueDropdown;
